import { Moment } from "moment";

/**
 * Format number with commas and 2 decimal places
 */
export const addCommasInPrices = (value: string | number): string => {
  return (parseFloat(String(value)) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export interface Category {
  id: string;
  category: string;
  totalRevenue: string | number;
  totalItemsSold: number;
  imageUrl?: string;
  revenue?: number;
  itemsSold?: number;
}

export interface KeyMetric {
  id: string;
  title: string;
  subTitle: string;
  value: string;
  icon: string;
  color: string;
}

export interface DateRange {
  startDate: Moment;
  endDate: Moment;
}

export interface Merchant {
  id: string;
  name?: string;
  role?: string;
  [key: string]: any;
}

export interface Store {
  id: string;
  name?: string;
  [key: string]: any;
}

export interface User {
  id: string;
  role: "admin" | "merchant" | string;
  [key: string]: any;
}

export interface KeyMetricsFilter {
  totalRevenue: string;
  averageRevenue: string;
  bestCategoryByRevenue: string;
  bestCategoryByUnitsSold: number;
}

export interface CategorySalesApiResponse {
  data: {
    categories: Category[];
  };
  message?: string;
  status?: number;
  success?: boolean;
}

export interface CategorySalesSummaryProps {
  weeklyChange: number;
  borderColor?: string;
  merchant: Merchant | null;
  storeId: string;
}

export interface CategorySalesRankingCarouselProps {
  data: Category[];
  rankingBy: "revenue" | "unitsSold";
  onToggleRanking: () => void;
}

export type RankingBy = "revenue" | "unitsSold";
export type ChartType = "line" | "bar";
export type MetricOption = "totalRevenue" | "totalItemsSold";
